<script setup>
const props = defineProps({
  channelType: {
    type: String,
    required: true,
  },
});

const { channelType } = props;

const channelTypeIconMap = {
  'Channel::Api': 'api',
  'Channel::Email': 'email',
  'Channel::FacebookPage': 'facebook',
  'Channel::Line': 'line',
  'Channel::Sms': 'sms',
  'Channel::Telegram': 'telegram',
  'Channel::TwilioSms': 'twilio',
  'Channel::TwitterProfile': 'twitter',
  'Channel::WebWidget': 'website',
  'Channel::Whatsapp': 'whatsapp',
  'Channel::Instagram': 'instagram',
  'Channel::SynphoneVoice': 'synvoice',
  'Channel::SynphoneMeet': 'synmeet',
};

function getChannelThumbnail() {
  const icon = channelTypeIconMap[channelType];
  return `/assets/images/dashboard/channels-icons/${icon}.png`;
}
</script>

<template>
  <img :src="getChannelThumbnail()" alt="" />
</template>
